export default __webpack_public_path__ + "static/church1-60da67c9c8c5b0053c46fdce28df98bc.jpg";